import { useCallback, useEffect, useRef } from 'react';
function useFunctionRef(fn) {
    const fnRef = useRef(fn);
    useEffect(() => {
        fnRef.current = fn;
    });
    return useCallback((...args) => { var _a; return (_a = fnRef.current) === null || _a === void 0 ? void 0 : _a.call(fnRef, ...args); }, []);
}
export default useFunctionRef;
//# sourceMappingURL=use-function-ref.js.map